import type { ComponentPropsWithRef } from 'react'

export interface MockBookingFormServiceProps extends ComponentPropsWithRef<'div'> {
    title: string
    description: string
    duration: number
    isRecurring?: boolean
}

export function MockBookingFormService({
    title,
    description,
    duration,
    isRecurring = false,
    className = '',
    ...restProps
}: MockBookingFormServiceProps) {
    return (
        <div
            {...restProps}
            className={`rounded-lg2 border border-slate-200 p-3 ${className}`.trim()}
        >
            <div className="text-base font-bold text-slate-900">{title}</div>
            <div className="mt-1 flex items-center gap-3 text-xs text-slate-600">
                <span className="inline-flex items-center gap-1">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        className="h-3.5 w-3.5"
                        aria-hidden="true"
                    >
                        <circle
                            cx="12"
                            cy="12"
                            r="9"
                        />
                        <path d="M12 7v5l3 2" />
                    </svg>
                    {duration} mins
                </span>
                {isRecurring ? (
                    <span className="inline-flex items-center gap-1">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                            className="h-3.5 w-3.5"
                            aria-hidden="true"
                        >
                            <path d="M3 12a9 9 0 0 1 15-6.7" />
                            <path d="M21 12a9 9 0 0 1-15 6.7" />
                            <path d="M18 2v4h-4" />
                            <path d="M6 22v-4h4" />
                        </svg>
                        Recurring
                    </span>
                ) : null}
            </div>
            <p className="mt-1.5 text-xs text-slate-600">{description}</p>
        </div>
    )
}
